module.exports = __webpack_public_path__ + "img/kr-product-card3-step2.1b84e95.png";